import getImagePath from "@Utils/getImagePath";
import config from "config/index";

const chinaSocialMediaData = [
  {
    name: "ThanksRED",
    id: "thanks_red",
    link: "https://www.xiaohongshu.com/user/profile/619c029e0000000010005b59",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/thanksred.svg`),
  },
  {
    name: "Douyin",
    id: "douyin",
    link: "https://www.douyin.com/user/MS4wLjABAAAAEw3NiIWRgncsm1MGDtCDQCf2xA1kO8iKs7j17qtaPDQ",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/tiktok.svg`),
  },
  {
    name: "Weibo",
    id: "weibo",
    link: "https://weibo.com/7793921375",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/weibo-logo.svg`),
  },
  {
    name: "Zhihu",
    id: "zhihu",
    link: "https://www.zhihu.com/org/amberstudent-an-bo-liu-xue-gong-yu",
    icon: getImagePath(`${config.IMAGE_STATIC_URL}/images/zhihu.svg`),
  },
];

export default chinaSocialMediaData;
